import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Hero = makeShortcode("Hero");
const DiscoverBlock = makeShortcode("DiscoverBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Hero slots="heading, text" background="rgb(233, 80, 80)" mdxType="Hero" />
    <h1 {...{
      "id": "adobe-firefly-services"
    }}>{`Adobe Firefly Services`}</h1>
    <p>{`Unleash boundless potential with Firefly Services advanced AI and Creative Cloud APIs.`}</p>
    <h2 {...{
      "id": "overview"
    }}>{`Overview`}</h2>
    <p>{`Welcome to Firefly Services, your solution for seamless content generation at scale.`}</p>
    <p>{`Firefly Services includes Firefly APIs, Lightroom APIs, Photoshop APIs, and Content Tagging APIs.`}</p>
    <p>{`These suites of APIs combine the power of Adobe's creative tools like Photoshop and Lightroom with cutting-edge AI/ML features like Content Tagging, Generative Fill, Text to Image, and more.`}</p>
    <p>{`With Firefly Services, you're not just creating – you're automating, scaling your content production, and harnessing the latest AI/ML technologies to supercharge your workflows.`}</p>
    <br /><br />
    <div style={{
      "display": "flex",
      "justifyContent": "center"
    }}> <iframe width="560" height="315" src="https://adobe.ly/ffs-overview" title="Introduction to Adobe Express Add-ons" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe> </div>
    <h2 {...{
      "id": "ready-to-get-started"
    }}>{`Ready to get started?`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Begin by navigating to the `}<a parentName="p" {...{
            "href": "./get-started.md"
          }}>{`Getting Started guide`}</a>{` to get set up and obtain your credentials.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Next, visit our `}<a parentName="p" {...{
            "href": "../firefly-api/guides/index.md"
          }}>{`Firefly API Quickstart guide`}</a>{` to begin interacting with Firefly Services.`}</p>
      </li>
    </ul>
    <h2 {...{
      "id": "discover"
    }}>{`Discover`}</h2>
    <DiscoverBlock slots="heading, link, text" mdxType="DiscoverBlock" />
    <h3 {...{
      "id": "get-started"
    }}>{`Get Started`}</h3>
    <p><a parentName="p" {...{
        "href": "../firefly-api/guides/index.md"
      }}>{`Firefly API Quickstart guide`}</a></p>
    <p>{`Get started with the Adobe Firefly Services.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "../firefly-api/guides/how-tos/firefly-generate-image-api-tutorial.md"
      }}>{`Firefly API Tutorials`}</a></p>
    <p>{`Explore our tutorials page for comprehensive guidance.`}</p>
    <DiscoverBlock slots="heading, link, text" mdxType="DiscoverBlock" />
    <h3 {...{
      "id": "api-references"
    }}>{`API References`}</h3>
    <p><a parentName="p" {...{
        "href": "../firefly-api/"
      }}>{`Firefly API`}</a></p>
    <p>{`Integrate generative AI into your creative workflows.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "../lightroom/"
      }}>{`Lightroom API`}</a></p>
    <p>{`Unlock the potential of Lightroom in the cloud.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "../photoshop/"
      }}>{`Photoshop API`}</a></p>
    <p>{`Unlock the potential of Photoshop in the cloud.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "https://developer.adobe.com/audio-video-firefly-services/?aio_internal"
      }}>{`Audio/Video API`}</a></p>
    <p>{`Audio/Video APIs are a collection of resources that leverage Firefly Services' AI to create and customize audio and video content.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "../indesign-apis/"
      }}>{`InDesign API`}</a></p>
    <p>{`Automate time-consuming design tasks with InDesign API.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "https://developer.adobe.com/firefly-services/docs/s3dapi/?aio_internal"
      }}>{`Substance 3D API`}</a></p>
    <p>{`Unlock generative AI for object rendering and composites.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/experience-platform/intelligent-services/content-commerce-ai/overview.html"
      }}>{`Content Tagging API`}</a></p>
    <p>{`Leverage Content Tagging API to craft personalized experiences.`}</p>
    <br /><br /><br /><br />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      